import fetch from "cross-fetch";
import {CMS_API_URL} from "../../config";
import { shouldFetchCirclesInCollection } from "./selectors.js";
import * as ActionCreators from "./creators";

export function fetchCirclesInCollection(collection, limit, offset, featured){
  return function(dispatch, getState) {
    if (
      !shouldFetchCirclesInCollection(getState(), collection, offset, featured)
    ) {
      return Promise.resolve();
    }
    dispatch(ActionCreators.fetchingCircles(collection, featured));
    let url = `${CMS_API_URL}/circlesincollections?is_published=true&_sort=updated_at:DESC&collection_key=${collection}&_limit=${limit +
      1}&_start=${offset}`;
    if (featured) {
      url += `&featured=true`;
    }
    
    return fetch(url)
      .then(
        response => response.json(),
        error => {
          dispatch(
            ActionCreators.errorFetchingCircles(error)
          );
        }
      )
      .then(response => {        
        let has_more = false;
        if (response.length > limit) {
          has_more = true;
          response = response.splice(0, limit);
        }
        dispatch(
          ActionCreators.fetchedCircles(response, collection, limit, offset, featured, has_more)
        );
        // let getting_circles = response.map((circle)=>{
        //   let url = `${API_URL}/prod/circle/${circle.circle_guid}`;
        //   return fetch(url).then(response => response.json()).then(response=>response.data);
        // })
         
        // return Promise.all(getting_circles).then(function(response) {
        //   dispatch(
        //     ActionCreators.fetchedCircles(response, limit, offset, featured, has_more)
        //   );
        // });       
      });
  }
}
  